module.exports = __webpack_public_path__ + "assets/pizza_disabled-7365e8.svg";